export const CHANGE_LOCALE = 'LanguageProvider/CHANGE_LOCALE';
